exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".app-wrapper[data-v-ac4ffd2a]{position:relative;height:100%;width:100%}.app-wrapper[data-v-ac4ffd2a]:after{content:\"\";display:table;clear:both}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ac4ffd2a","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/layouts/Layout.vue
// module id = 1139
// module chunks = 0